<template>
  <div><strong>Replies:</strong>
    <a-list item-layout="horizontal" v-if="dataFromParent" :data-source="dataFromParent">
      <a-list-item slot="renderItem" slot-scope="item" >
        <a-list-item-meta >
          <a slot="title" href="https://www.antdv.com/">{{ item.created_by.first_name }} {{ item.created_by.last_name }} <span style="float: right;">{{ item.created_at }}</span></a>
          <a slot="description">{{ item.reply_text }}</a>
          <a slot="description" v-if="item.files.length !== 0 "><br><br></a>
          <a slot="description" v-for="(replyFile, index) in item.files" :key="index"  :href="replyFile.file" target="_blank"><span class="fa fa-download"></span> {{replyFile.file.split('/').pop()}}</a>
          <a-avatar
            slot="avatar"
            src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
          />
        </a-list-item-meta>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
const data = []
export default {
  name: 'SupportRequestReplies',
  props: {
    dataFromParent: [],
  },
  data() {
    return {
      data,
    }
  },
}
</script>
<style></style>
